import Container from '../../components/Common/Container/Container';
import FullScreen from '../../components/Common/FullScreen/FullScreen';
import PasswordExpiredForm from '../../components/Login/PasswordExpiredForm/PasswordExpiredForm';
import { Spacing } from '../../types/appTypes';

const PasswordExpiredPage = () => {
  return (
    <FullScreen>
      <Container margin={[Spacing.Auto]}>
        <PasswordExpiredForm />
      </Container>
    </FullScreen>
  );
};

export default PasswordExpiredPage;
